import { render, staticRenderFns } from "./single-search.vue?vue&type=template&id=e55f5e64&scoped=true"
import script from "./single-search.vue?vue&type=script&lang=ts"
export * from "./single-search.vue?vue&type=script&lang=ts"
import style0 from "./single-search.vue?vue&type=style&index=0&id=e55f5e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f5e64",
  null
  
)

export default component.exports